const partyColorMap = [
  {
    label: "काँग्रेस",
    id: 2,
    lead: "#A5D6A7",
    won: "#43A047"
  },
  {
    label: "एमाले",
    id: 3,
    lead: "#EF9A9A",
    won: "#E53935"
  },
  {
    label: "माओवादी",
    id: 12,
    lead: "#80DEEA",
    won: "#00ACC1"
  },
  {
    label: "फोरम",
    id: 4,
    lead: "#90CAF9",
    won: "#1E88E5"
  },
  {
    label: "राजपा",
    id: 11,
    lead: "#FFF59D",
    won: "#FDD835"
  },
  {
    label: "अन्य",
    id: 0,
    lead: "#CE93D8",
    won: "#8E24AA"
  }
]

export default partyColorMap;


// WEBPACK FOOTER //
// ./src/partyColorMap.js